import { IApplicationState } from '../../../../types/types';
import { getAuthUser } from './getAuthUser';

export const getAuthUserAllowCardTagCount = (
    state: IApplicationState
): number => {
    const user = getAuthUser(state);
    return user.allowColorTagCount;
}
